import { Placeholder, Step } from '@de/types';

/**
 * Main function to translate placeholders in text
 * @param text - The text containing placeholders
 * @param placeholders - Array of placeholder definitions
 * @param placeholdersToTranslateValues - Object containing placeholders to translate values
 * @returns Translated text with placeholders replaced
 */
const translatePlaceholderForAttribute = (
  text: string,
  placeholders: Placeholder[],
  placeholdersToTranslateValues: Record<string, string> = {},
): string => {
  if (!text || !placeholders?.length) return text;

  let translatedText = text;

  placeholders.forEach((placeholder) => {
    try {
      const key = placeholder.key.toLowerCase();
      if (translatedText.includes(placeholder.key)) {
        const replacementValue =
          placeholdersToTranslateValues[key as keyof Record<string, string>] ||
          placeholder.defaultValue;
        translatedText = translatedText
          .split(placeholder.key)
          .join(replacementValue);
      }
    } catch (error) {
      console.warn(
        `Failed to translate placeholder ${placeholder.key}:`,
        error,
      );
    }
  });

  return translatedText;
};

export const translateStringFields = (
  step: Step,
  placeholders: Placeholder[],
  placeholdersToTranslateValues: Record<string, string>,
): Step => {
  if (!step || typeof step !== 'object') return step;

  const result = { ...step } as Record<string, any>;

  Object.keys(result).forEach((key: string) => {
    if (typeof result[key] === 'string') {
      result[key] = translatePlaceholderForAttribute(
        result[key],
        placeholders,
        placeholdersToTranslateValues,
      );
    } else if (Array.isArray(result[key])) {
      // Process arrays
      result[key] = result[key].map((item: string | Step) => {
        if (typeof item === 'string') {
          return translatePlaceholderForAttribute(
            item,
            placeholders,
            placeholdersToTranslateValues,
          );
        } else if (item && typeof item === 'object') {
          //Call this function again for nested objects
          return translateStringFields(
            item,
            placeholders,
            placeholdersToTranslateValues,
          );
        }
        return item;
      });
    } else if (result[key] && typeof result[key] === 'object') {
      //Call this function again for nested objects
      result[key] = translateStringFields(
        result[key],
        placeholders,
        placeholdersToTranslateValues,
      );
    }
  });

  return result as Step;
};
